import React, { useMemo } from "react";

const StockDetail = ({ stock }) => {
  const subtypes = useMemo(() => {
    const subTypesByName = stock.subtypes.reduce((acc, subtype) => {
      if(acc[subtype.name]) {
        acc[subtype.name].stock += parseFloat(subtype.stock);
      } else {
        acc[subtype.name] = Object.assign({}, subtype);
        acc[subtype.name].stock = parseFloat(subtype.stock);
      }

      return acc;
    }, {});
    
    return Object.values(subTypesByName);
  }, [stock]);

  return (
    <div style={{
      maxWidth: '400px',
    }}>
      <div style={{
        display: 'flex',
        borderBottom: '1px solid #6A6A6A',
        padding: '12px 4px',
        marginBottom: '20px',
      }}>
        <div
          className="circle-ingreso"
          style={{
            backgroundColor: stock.color,
            border: stock.name === "Plásticos" ? "1px solid #6A6A6A" : "none"
          }}
        ></div>
        <div style={{ flexGrow: 1, textAlign: 'center' }}>
          <strong>{stock.name}</strong>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        {subtypes.map((subtype, key) => {
          return (
            <div
              key={`subtype-${key}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <div style={{ flexGrow: 1, textAlign: 'left' }}>
                <strong>{subtype.name}</strong>
              </div>
              <div style={{ flexGrow: 1, textAlign: 'right' }}>
                {(subtype.stock / 1000).toFixed(2)} T
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StockDetail;